import useMutationUpdateIntegrationVersionConfig from './useMutationUpdateIntegrationVersionConfig';
import useQueryIntegrationVersionConfig from './useQueryIntegrationVersionConfig';

const useIntegrationVersionConfig = ({
  integrationId,
  integrationVersion,
  optionsUseQueryIntegrationVersionConfig,
  optionsUseMutationUpdateIntegrationVersionConfig,
}: {
  integrationId: number;
  integrationVersion: string;
  optionsUseQueryIntegrationVersionConfig;
  optionsUseMutationUpdateIntegrationVersionConfig;
}) => {
  const {
    data: integrationVersionConfig,
    isLoading,
  } = useQueryIntegrationVersionConfig(
    {
      integrationId,
      integrationVersion,
    },
    optionsUseQueryIntegrationVersionConfig
  );
  const {
    isLoading: isUpdating,
    mutateAsync: update,
  } = useMutationUpdateIntegrationVersionConfig(
    {
      integrationId,
      integrationVersion,
    },
    optionsUseMutationUpdateIntegrationVersionConfig
  );

  return {
    isLoading,
    isUpdating,
    isWorking: isLoading || isUpdating,
    integrationVersionConfig,
    update,
  };
};

export default useIntegrationVersionConfig;
